module.exports = __webpack_public_path__ + "static/Symphonia4-87a1be397eb800c469b1d6bf4836b515.png";